
import { translations } from './translation.js'; 

document.addEventListener( 'DOMContentLoaded', () => {

    const lang = document.documentElement.lang.split('-')[0];

    // For now, the TAC translation are defines in js
    const contents = translations[lang] || translations['en'];

    tarteaucitronCustomText = {
        'middleBarHead'  : contents.middleBarHead,
        'alertBigPrivacy': '<span class="tarteaucitronDisclaimerAlertBrand">' + TarteaucitronGoOptions.brand + '</span>'
                         + '<span class="tarteaucitronDisclaimerAlertTitle">' + contents.alertBigPrivacy.title + '</span>'
                         + '<span class="tarteaucitronDisclaimerAlertText">'  + contents.alertBigPrivacy.text  + '</span>',
        'acceptAll'      : contents.acceptAll,
        'denyAll'        : contents.denyAll,
        'personalize'    : contents.personalize,
    };


    // Customize the brand :
    window.addEventListener('tac.root_available', () => {
        const brand   = document.querySelector('.tarteaucitronDisclaimerAlertBrand') ;
        const favicon = TarteaucitronGoOptions?.favicon || '' ;
        if( brand && '' !== favicon ) {
            brand.classList.add('tarteaucitronDisclaimerAlertBrand--favion');
            brand.style.backgroundImage = 'url(' + favicon + ')';
        }
    });

    // Init 
    tarteaucitron.init({
        "privacyUrl": "", /* Privacy policy url */
        "bodyPosition": "bottom", /* or top to bring it as first element for accessibility */
        "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
        "cookieName": "tarteaucitron", /* Cookie name */
        "orientation": "popup", /* Banner position (top - bottom - middle - popup) */
        "groupServices": false, /* Group services by category */
        "showDetailsOnClick": true, /* Click to expand the description */
        "serviceDefaultState": "wait", /* Default state (true - wait - false) */
        "showAlertSmall": false, /* Show the small banner on bottom right */
        "cookieslist": false, /* Show the cookie list */
        "showIcon": true, /* Show cookie icon to manage cookies */
        // "iconSrc": "", /* Optional: URL or base64 encoded image */
        "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */
        "adblocker": false, /* Show a Warning if an adblocker is detected */
        "DenyAllCta" : true, /* Show the deny all button */
        "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
        "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
        "alwaysNeedConsent": false, /* Ask the consent for "Privacy by design" services */
        "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
        "removeCredit": true, /* Remove credit link */
        "moreInfoLink": true, /* Show more info link */
        "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
        "useExternalJs": false, /* If false, the tarteaucitron.services.js file will be loaded */
        // "cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */
        "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */
        "mandatory": true, /* Show a message about mandatory cookies */
        "mandatoryCta": true, /* Show the disabled accept button when mandatory on */
        // "customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */
        "googleConsentMode": true, /* Enable Google Consent Mode v2 for Google ads and GA4 */
        "partnersList": false /* Details the number of partners on the popup and middle banner */
    });

    (tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
    (tarteaucitron.job = tarteaucitron.job || []).push('youtube');

    // Deny on BackDrop Click
    const backDrop = document.querySelector('.tarteaucitron-go-backdrop');
    backDrop.addEventListener('click', () => {
        const denyButton = document.querySelector('.tarteaucitronDeny');
        if( denyButton ) {
            denyButton.click();
        }
    });
});